import { useEffect } from 'react';
import { useFormikContext } from 'formik';
import { useSelector } from 'react-redux';
import { useLocation, useHistory } from 'react-router-dom';
import type { FieldTypes } from '../Fields';
import { opzetApi } from '../../../store/slices/OpzetApi';
import { RootState } from '../../../store/reducers';

const SubmitUrlParams = () => {
  const {
    values,
    submitForm,
    setFieldValue,
    dirty,
  } = useFormikContext<FieldTypes>();
  const location = useLocation();
  const history = useHistory();
  const data = useSelector((state: RootState) => opzetApi.endpoints.addressSuggest.select({ postal_code: values.postal_code, housenumber: values.house_number })(state)?.data);

  // Submit the form with the address information.
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const postcode = params.get('postcode');
    const huisnummer = params.get('huisnummer');

    if (postcode && huisnummer && dirty) {
      params.delete('postcode');
      params.delete('huisnummer');
      history.replace({ search: params.toString() });

      submitForm();
    }
  }, [dirty]);

  // Set the form values when URL params are present.
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const postcode = params.get('postcode');
    const huisnummer = params.get('huisnummer');

    if (postcode) {
      setFieldValue('postal_code', postcode);
    }

    if (huisnummer) {
      setFieldValue('house_number', huisnummer);
    }
  }, [location.search, submitForm, setFieldValue]);

  useEffect(() => {
    if (!data) return;

    const params = new URLSearchParams(location.search);
    const huisletter = params.get('huisletter');
    const toevoeging = params.get('toevoeging');

    if (!huisletter && !toevoeging) return;

    const address = data.find((item) => {
      const matchesHuisletter = huisletter ? item.huisletter.toLocaleLowerCase() === huisletter.toLocaleLowerCase() : true;
      const matchestoevoeging = toevoeging ? item.toevoeging.toLocaleLowerCase() === toevoeging.toLocaleLowerCase() : true;
      return matchesHuisletter && matchestoevoeging;
    });

    params.delete('huisletter');
    params.delete('toevoeging');
    history.replace({ search: params.toString() });

    if (address) {
      setFieldValue('selection', address.bagid);
      /**
       * To prevent race conditions where the `submitForm` does not have the updated `values` yet,
       * We set a timeout of 0. This will prevent the issue and ensure the form is submitted with the correct values.
       */
      setTimeout(() => {
        submitForm();
      }, 0);
    }
  }, [location.search, submitForm, setFieldValue, history, data]);

  return null;
};

export default SubmitUrlParams;
